import useQueryParams from "@packages/hooks/useQueryParams";
import { SortOptions } from "../../models/university-course-reviews/review.model";
import Image from "next/image";
import { GA4DataLayer } from "@packages/lib/utlils/helper-function";
import { GAConstants } from "../services/constants";

const ReviewSort = ({ commonGAAttrs }: { commonGAAttrs?: any }) => {
  let [currentQueryParams] = useQueryParams();
  const currentSort = currentQueryParams?.sortBy || SortOptions.Latest;

  const sortOptions = [
    { value: SortOptions.Latest, label: "Latest reviews" },
    { value: SortOptions.Oldest, label: "Oldest reviews" },
    { value: SortOptions.HighRated, label: "Highest reviews" },
    { value: SortOptions.LowRated, label: "Lowest reviews" },
  ];

  const handleSortChange = (event: any, sortValue: string) => {
    event.preventDefault();
    event.stopPropagation();
    const params = new URLSearchParams(window.location.search);
    params.set("sortBy", sortValue);
    const ga4Data = {
      ...commonGAAttrs,
      // event: "ga_events",
      // eventName: "ai_summarised_reviews",
      // data_label: "review_content_detailed_click",
      // data_label2: "sort_by_click",
      // data_label3: sortValue,
      event: GAConstants.track_event,
      event_name: "sort_by",
      click_text: sortValue,
    };
    GA4DataLayer(ga4Data);
    window.history.replaceState(null, "", `?${params.toString()}`);
  };

  const currentLabel =
    sortOptions.find((option) => option.value === currentSort)?.label ||
    "Latest reviews";

  return (
    <div className="relative group font-inter md:inline-flex">
      <div className="inline-flex items-center text-right justify-start">
        <Image
          id="filter-icon"
          src="/static/assets/icons/sort-icon.svg"
          alt="Video thumbnail"
          width={16}
          height={16}
        />
        <span className="ml-[4px] border-b border-grey300">
          <span className="text-grey300 text-sm font-semibold font-inter">
            Sort:
          </span>
          <span className="ml-[4px] text-grey300 text-sm font-normal font-inter">
            {currentLabel}
          </span>
        </span>
      </div>
      <div className="bg-white z-[1] shadow-custom-3 rounded-[4px] absolute right-0 top-full opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 min-w-[150px]">
        <ul>
          {sortOptions
            .filter((option) => option.value !== currentSort)
            .map((option) => (
              <li key={option.value}>
                <button
                  type="button"
                  className="block w-full text-left small px-[16px] py-[12px] hover:bg-blue-50 hover:underline cursor-pointer"
                  onClick={(event) => handleSortChange(event, option.value)}
                >
                  {option.label}
                </button>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default ReviewSort;
